import RuleProvider from 'diagram-js/lib/features/rules/RuleProvider';
import EventBus from 'diagram-js/lib/core/EventBus';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import {Shape} from 'diagram-js/lib/model';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {processType} from '@ispm-shared/modules/bpmn';

export class ConnectionDragRule extends RuleProvider {

  constructor(eventBus: EventBus) {
    super(eventBus);
  }

  init() {
    super.addRule('connection.create', 10001, (context) => {
      const source: Shape = context.source;
      const target: Shape = context.target;
      if (target && ModelingUtil.isOnTheSameTreeLayer(source, target) && !ModelingUtil.hasLoopBetweenNodes(source, target)) {
        const sourceHasChildrenNodes = ModelingUtil.hasActiveChild(source);
        const sourceHasParent = source.incoming ? source.incoming.length > 0 : false;
        const targetHasParent = target.incoming ? target.incoming.length > 0 : false;
        // allow connection only for the source node brother gateway
        const sourceNodeType = ModelingUtil.getNodeType(source);
        const targetNodeType = ModelingUtil.getNodeType(target);
        const sourceHasOutgoingGateway = ModelingUtil.getNodeOutGoingGateway(source);
        const targetHasIncomingGateway = ModelingUtil.getNodeIncomingGateway(target);


        if (ModelingUtil.getElementType(target) !== processType && source.id !== target.id &&
          !ModelingUtil.isGateway(source) &&
          !ModelingUtil.isGateway(target) &&
          !ModelingUtil.hasDeletionTrackingChange(target)) {
            if (sourceHasOutgoingGateway && targetHasIncomingGateway ||
              (ModelingUtil.hasChildren(source) && !ModelingUtil.AllOutgoingConnectionWithDeletedTrackingChange(source)
                && ModelingUtil.getNodeType(target) === NodeType.treatment)) {
                // never connecting between gateways and between node with children to treatment plan node
                return false;
            }

          if (targetNodeType === NodeType.normal ||
            targetNodeType === NodeType.treatment ||
            targetNodeType === NodeType.neighborhood_entry) {
            return true;
          }

          if (!sourceHasChildrenNodes && sourceHasParent && sourceNodeType === NodeType.normal) {
            if (ModelingUtil.getNodeType(target) === NodeType.normal || ModelingUtil.getNodeType(target) == NodeType.treatment) {
              return true;
            }
          }
        }

      }
      return false;
    });
  }

}
